<ng-container *ngIf="!qualification.childs?.length">
  <div class="d-flex custom_btn_design">
    <div class="add_btn">
      <a
        *ngIf="quotaFlags.add"
        class="adv-quotas"
        (click)="openQuotaModal(qualification)"
        [ngClass]="{ 'btn-disabled': isQlcLiveSurvey }"
      >
        Add Quotas
      </a>
      <a
        *ngIf="quotaFlags.edit"
        class="adv-quotas"
        (click)="openQuotaModal(qualification)"
      >
        Edit Quotas
      </a>
    </div>
    <a
      *ngIf="quotaFlags.delete"
      class="adv-quotas"
      (click)="deleteQuotas(qualification)"
      [ngClass]="{ 'btn-disabled': isQlcLiveSurvey }"
    >
      Delete Quotas
    </a>
  </div>
</ng-container>
